__turbopack_context__.v({
  "helpText": "Select-module__U7cVnq__helpText",
  "select": "Select-module__U7cVnq__select",
  "selectError": "Select-module__U7cVnq__selectError",
  "selectWrapper": "Select-module__U7cVnq__selectWrapper",
});
